import { constants as config } from '@config';
import Store from '@store';
import { getAssetsData } from 'src/store/selectors/assets.selector';

const template = require('./add-to-assets.hbs');

const LibraryFactory = require('../../../../factory/library').factory;
const LibraryPopulator = require('../../../../factory/library/library-populator');
const DesignFacade = require('../../../../facade/design/design');
const UserInfoFactory = require('../../../../factory/user-info');
const CompanyFactory = require('../../../../factory/company').instance;

module.exports = Backbone.View.extend({
  resourceType: undefined,
  librarySource: 'member',
  workspaceLibrary: null,
  libraryInstance: null,

  events: {
    'click .apply.btn': 'applyEvent',
    'change .add-to-library-options input[name="library-type"]': 'changeType',
    'change .add-to-library-options input[name="library-source"]': 'changeSource'
  },

  isUserLibrary: function () {
    return this.librarySource === 'member';
  },

  applyEvent: async function () {
    this.libraryInstance = new LibraryFactory({
      librarySource: this.librarySource,
      domain: this.companyDomain
    });
    const type = `${this.resourceType}s`;

    this.isUserLibrary() || LibraryPopulator.once(
      `new.${type}`,
      item => {
        DesignFacade.set(this.element.getAttribute('id'), {
          smart_asset: item.id,
          type,
          just_added: item
        });
      }
    );

    LibraryPopulator.setLibrary(this.libraryInstance);
    LibraryPopulator.addElementToLibrary(
      this.element, this.resourceType, true
    );

    this.updateButton();
  },

  changeType: function (event) {
    this.resourceType = event.target.value;
  },

  changeSource: function (event) {
    this.librarySource = event.target.value;

    this.updateButton();
  },

  initialize: async function (options) {
    this.element = options.selectedElement;

    const companyData = await CompanyFactory.getCompanyData();
    this.companyDomain = companyData?.domain;

    const userInfo = await UserInfoFactory.getMembership();
    this.canManage = userInfo?.permissions.assets_manage;
    this.librarySource = this.canManage ? 'workspace' : 'member';

    this.render();
    this.updateButton();
  },

  render: function () {
    const id = $(this.element).is('.background') ? 'background' : this.element.getAttribute('id');

    const data = DesignFacade.get(id);
    if (!data) return;

    this.resourceType = ['sticker', 'group', 'shape', 'qrcode'].includes(data.type) ? 'icon' : data.type;

    const options = this._compileOptions();

    const html = template({ options });
    this.$el.html(html);
  },

  updateButton: function () {
    const btn = document.querySelector('#add-to-assets-btn');
    if (btn) {
      this._isButtonDisabled()
        ? btn.setAttribute('disabled', true)
        : btn.removeAttribute('disabled');
    }
  },

  _compileOptions: function () {
    const sourceOptions = [
      {
        title: INKIVE.TranslateHelper.translate('popupmenu.library.add_to_user'),
        value: 'member',
        selected: this.isUserLibrary()
      }
    ];

    this.canManage && sourceOptions.unshift({
      title: INKIVE.TranslateHelper.translate('popupmenu.library.add_to_workspace'),
      value: 'workspace',
      selected: !this.isUserLibrary()
    });

    const options = {
      type: [],
      source: sourceOptions
    };

    switch (this.resourceType) {
      case 'icon':
        options.type = [
          { title: INKIVE.TranslateHelper.translate('popupmenu.library.add_as_icon'), value: 'icon', selected: true },
          { title: INKIVE.TranslateHelper.translate('popupmenu.library.add_as_logo'), value: 'logo', selected: false }
        ];
        break;
      case 'logo':
        options.type = [
          { title: INKIVE.TranslateHelper.translate('popupmenu.library.add_as_logo'), value: 'logo', selected: true },
          { title: INKIVE.TranslateHelper.translate('popupmenu.library.add_as_icon'), value: 'icon', selected: false }
        ];
        break;

      default:
        options.type = [
          {
            title: INKIVE.TranslateHelper.translate(`popupmenu.library.add_as_${this.resourceType}`),
            value: this.resourceType,
            selected: true
          }
        ];
    }

    return options;
  },

  _isButtonDisabled: function () {
    let disabled = false;
    const definedAssetAttr = config.smartAssets.attributes.definedAsset;
    if (this.element.hasAttribute(definedAssetAttr)) {
      const state = Store.getState();
      const definedAsset = this.element.getAttribute(definedAssetAttr).toString()
        .split(',')
        .map(getAssetsData(state, 'definedAssets'))
        .some(asset => asset && !config.smartAssets.descriptionalTypes.includes(asset.type));

      disabled = !this.isUserLibrary() && definedAsset;
    }

    return disabled;
  }
});
